module.exports = __webpack_public_path__ + "static/img/bg-en.326fa74a.png";